module.exports = __webpack_public_path__ + "img/login-bg.bd07a6f6.png";